import { render } from "./NewExport.vue?vue&type=template&id=31442bf7"
import script from "./NewExport.vue?vue&type=script&lang=js"
export * from "./NewExport.vue?vue&type=script&lang=js"

import "./NewExport.vue?vue&type=style&index=0&id=31442bf7&lang=css"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__